import React from "react";
import { FieldValues, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  authService,
  setCustomerAsync,
  setUser,
  setVersions,
  useAppDispatch,
  UserRole,
  versionService,
} from "@shared/ui";
import { useNavigate } from "react-router-dom";

const LoginForm: React.FC<{setResetPassword: (value: boolean) => void}> = ({setResetPassword}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      login: "",
      password: "",
    },
  });

  const submitLogin = async (model: FieldValues) => {
    try {
      const data = await authService.login(model.login, model.password);
      if ("access" in data) {
        versionService.getVersions().then((data) => {
          dispatch(setVersions(data));
        });
        dispatch(setUser(data.user));
        if (data.user.customerId) {
          dispatch(
            setCustomerAsync({
              id: data.user.customerId,
              name: data.user.customerName,
            }),
          );
        }
        if (data.user.role == UserRole.SuperAdmin) {
          navigate("/customers");
        } else {
          navigate("/dashboard");
        }
      }
    } catch {}
  };

  return (
    <form onSubmit={handleSubmit(submitLogin)}>
      <label>{t("login.labels.operator")}</label>
      <input {...register("login", { required: true, maxLength: 50 })} />
      {errors.login && (
        <span className="error">{t("login.errors.required")}</span>
      )}

      <label htmlFor="password">{t("login.labels.password")}</label>
      <input
        id="password"
        {...register("password", {
          required: true,
          minLength: {
            value: 5,
            message: "min length is 5",
          },
        })}
        type="password"
      />
      {errors.password && (
        <span className="error">{t("login.errors.required")}</span>
      )}
      <div className="text-right">
        <button type="button" className="btn-text" onClick={() => setResetPassword(true)}>{t("login.buttons.forgotPassword")}</button>
      </div>
      <input type="submit" value={t("login.buttons.enter")} />
    </form>
  )
};

export default LoginForm;